/* eslint-disable */
!(function (e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define('MRClient', [], t)
    : 'object' == typeof exports
    ? (exports.MRClient = t())
    : (e.MRClient = t());
})(this, function () {
  return (function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = (n[r] = { exports: {}, id: r, loaded: !1 });
      return e[r].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports;
    }
    var n = {};
    return (t.m = e), (t.c = n), (t.p = ''), t(0);
  })([
    function (e, t, n) {
      'use strict';
      function r(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function o(e, t) {
        if (!(e instanceof t))
          throw new TypeError('Cannot call a class as a function');
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var i =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          },
        s = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        })(),
        u = n(2),
        a = n(3),
        c = r(a),
        f = n(4),
        l = r(f),
        d = n(1),
        h = (r(d), n(7)),
        p = (function () {
          function e(t) {
            o(this, e),
              (this._apiUrl = t.apiUrl || u.API_URL),
              (this._tokenUrl = t.tokenUrl || this._apiUrl),
              (this._clientId = t.clientId),
              (this._clientSecret = t.clientSecret),
              (this._refreshRequest = null),
              (this.auth = c.default.bind(this)()),
              (this.event = l.default.bind(this)()),
              (this.event.listeners = new Map()),
              t.token && this.auth.setToken(t.token);
          }
          return (
            s(e, [
              {
                key: 'request',
                value: function (e, t) {
                  var n = this;
                  this.event.emit(u.EVENT_PRE_REQUEST, this);
                  var r = t.method,
                    o = t.query,
                    i = t.body,
                    s = new Headers(),
                    a = void 0 === t.auth || t.auth,
                    c = void 0 === t.json || t.json,
                    f = void 0 !== t.formdata && t.formdata,
                    l = this._token;
                  if (a && l) {
                    if (l.isExpired())
                      return (
                        (void 0 !== this._refreshRequest &&
                          null !== this._refreshRequest) ||
                          (this._refreshRequest = l.refreshToken
                            ? this.auth.refreshAuthentication(l.refreshToken)
                            : this.auth.applicationAuthentication()),
                        this._refreshRequest.then(function () {
                          return n.request(e, t);
                        })
                      );
                    s.append('Authorization', 'Bearer ' + l.accessToken);
                  }
                  return (
                    i &&
                      !f &&
                      (c
                        ? (s.append('Content-Type', 'application/json'),
                          (i = JSON.stringify({ data: i })))
                        : (s.append(
                            'Content-Type',
                            'application/x-www-form-urlencoded'
                          ),
                          (i = (0, h.stringify)(i)))),
                    o &&
                      (e = decodeURIComponent(e + '?' + (0, h.stringify)(o))),
                    fetch('' + (t.baseUrl ? t.baseUrl : this._apiUrl) + e, {
                      method: r,
                      headers: s,
                      body: 'GET' !== r && i ? i : void 0,
                    })
                  );
                },
              },
              {
                key: 'upload',
                value: function (e, t, n) {
                  var r = this;
                  return new Promise(function (e, n) {
                    var r = new FileReader();
                    (r.onerror = r.onabort =
                      function () {
                        return n(null);
                      }),
                      (r.onloadend = function (t) {
                        return e(t.target.result);
                      }),
                      r.readAsArrayBuffer(t);
                  }).then(function (t) {
                    return (
                      (t = new Uint8Array(t || '').reduce(function (e, t, n) {
                        return (e =
                          1 == n
                            ? String.fromCharCode(e, t)
                            : e + String.fromCharCode(t));
                      })),
                      r.request(e, {
                        method: 'POST',
                        body: i({}, n || {}, { file: btoa(t) }),
                      })
                    );
                  });
                },
              },
            ]),
            e
          );
        })();
      t.default = p;
    },
    function (e, t) {
      'use strict';
      function n(e, t) {
        if (!(e instanceof t))
          throw new TypeError('Cannot call a class as a function');
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var r = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        })(),
        o = (function () {
          function e(t) {
            n(this, e),
              (this.accessToken = t.accessToken),
              (this.refreshToken = t.refreshToken),
              (this.expiredAt = t.expiredAt);
          }
          return (
            r(e, [
              {
                key: 'isExpired',
                value: function () {
                  return this.expiredAt < Date.now();
                },
              },
            ]),
            e
          );
        })();
      t.default = o;
    },
    function (e, t) {
      'use strict';
      Object.defineProperty(t, '__esModule', { value: !0 });
      (t.API_URL = 'http://api.ma-residence.fr'),
        (t.OAUTH_TOKEN_URL = '/oauth/v2/token'),
        (t.OAUTH_GRANT_CLIENT_CREDENTIALS = 'client_credentials'),
        (t.OAUTH_GRANT_REFRESH_TOKEN = 'refresh_token'),
        (t.OAUTH_GRANT_PASSWORD = 'password'),
        (t.OAUTH_GRANT_EXTERNAL = 'urn:external'),
        (t.EVENT_PRE_REQUEST = 'pre_request'),
        (t.EVENT_PRE_AUTH = 'pre_auth'),
        (t.EVENT_POST_AUTH = 'post_auth'),
        (t.EVENT_FAIL_AUTH = 'fail_auth');
    },
    function (e, t, n) {
      'use strict';
      function r(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function o() {
        var e = this;
        return {
          applicationAuthentication: function () {
            return e.auth._requestToken({
              client_id: e._clientId,
              client_secret: e._clientSecret,
              grant_type: s.OAUTH_GRANT_CLIENT_CREDENTIALS,
            });
          },
          userAuthentication: function (t) {
            var n = { client_id: e._clientId, client_secret: e._clientSecret };
            if (t.email && t.password)
              n = i({}, n, {
                username: t.email,
                password: t.password,
                grant_type: s.OAUTH_GRANT_PASSWORD,
              });
            else {
              if (!t.token || !t.service)
                throw Error(
                  'You must specify (email, password) OR (token, service).'
                );
              n = i({}, n, {
                token: t.token,
                type: t.service,
                grant_type: s.OAUTH_GRANT_EXTERNAL,
              });
            }
            return e.auth._requestToken(n);
          },
          refreshAuthentication: function (t) {
            return e.auth
              ._requestToken({
                client_id: e._clientId,
                client_secret: e._clientSecret,
                grant_type: s.OAUTH_GRANT_REFRESH_TOKEN,
                refresh_token: t,
              })
              .then(function () {
                e._refreshRequest = null;
              });
          },
          _requestToken: function (t) {
            return (
              e.event.emit(s.EVENT_PRE_AUTH, e),
              e
                .request(s.OAUTH_TOKEN_URL, {
                  method: 'POST',
                  body: t,
                  auth: !1,
                  json: !1,
                  baseUrl: e._tokenUrl,
                })
                .then(function (t) {
                  if (200 === t.status) return t.json();
                  throw (
                    (e.auth.logout(),
                    e.event.emit(s.EVENT_FAIL_AUTH, e),
                    Error('Authentication fail!'))
                  );
                })
                .then(function (t) {
                  var n = new Date();
                  n.setSeconds(n.getSeconds() + t.expires_in);
                  var r = new a.default({
                    accessToken: t.access_token,
                    refreshToken: t.refresh_token || null,
                    expiredAt: n,
                  });
                  return (
                    e.auth.setToken(r), e.event.emit(s.EVENT_POST_AUTH, e), r
                  );
                })
            );
          },
          isAuthenticated: function () {
            return e._token && !e._token.isExpired();
          },
          logout: function () {
            (e._token = null), (e._refreshRequest = null);
          },
          setToken: function (t) {
            return (
              (e._token = new a.default({
                accessToken: t.accessToken,
                expiredAt: t.expiredAt,
                refreshToken: t.refreshToken,
              })),
              e._token
            );
          },
          getToken: function () {
            return e._token;
          },
        };
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var i =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        };
      t.default = o;
      var s = n(2),
        u = n(1),
        a = r(u);
    },
    function (e, t) {
      'use strict';
      function n() {
        var e = this;
        return {
          listeners: Map,
          _isCallable: function (e) {
            return 'function' == typeof e || !1;
          },
          addListener: function (t, n) {
            e.event._isCallable(n) &&
              (e.event.listeners.has(t) || e.event.listeners.set(t, []),
              e.event.listeners.get(t).push(n));
          },
          removeListener: function (t, n) {
            var r = e.event.listeners.get(t),
              o = void 0;
            return (
              !!(
                r &&
                r.length &&
                ((o = r.reduce(function (t, r, o) {
                  return e.event._isCallable(r) && r === n ? (t = o) : t;
                }, -1)),
                o > -1)
              ) && (r.splice(o, 1), e.event.listeners.set(t, r), !0)
            );
          },
          emit: function (t) {
            for (
              var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), o = 1;
              o < n;
              o++
            )
              r[o - 1] = arguments[o];
            var i = e.event.listeners.get(t);
            return (
              !(!i || !i.length) &&
              (i.forEach(function (e) {
                e.apply(void 0, r);
              }),
              !0)
            );
          },
        };
      }
      Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = n);
    },
    function (e, t) {
      'use strict';
      function n(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
      e.exports = function (e, t, r, o) {
        (t = t || '&'), (r = r || '=');
        var i = {};
        if ('string' != typeof e || 0 === e.length) return i;
        var s = /\+/g;
        e = e.split(t);
        var u = 1e3;
        o && 'number' == typeof o.maxKeys && (u = o.maxKeys);
        var a = e.length;
        u > 0 && a > u && (a = u);
        for (var c = 0; c < a; ++c) {
          var f,
            l,
            d,
            h,
            p = e[c].replace(s, '%20'),
            _ = p.indexOf(r);
          _ >= 0
            ? ((f = p.substr(0, _)), (l = p.substr(_ + 1)))
            : ((f = p), (l = '')),
            (d = decodeURIComponent(f)),
            (h = decodeURIComponent(l)),
            n(i, d)
              ? Array.isArray(i[d])
                ? i[d].push(h)
                : (i[d] = [i[d], h])
              : (i[d] = h);
        }
        return i;
      };
    },
    function (e, t) {
      'use strict';
      var n = function (e) {
        switch (typeof e) {
          case 'string':
            return e;
          case 'boolean':
            return e ? 'true' : 'false';
          case 'number':
            return isFinite(e) ? e : '';
          default:
            return '';
        }
      };
      e.exports = function (e, t, r, o) {
        return (
          (t = t || '&'),
          (r = r || '='),
          null === e && (e = void 0),
          'object' == typeof e
            ? Object.keys(e)
                .map(function (o) {
                  var i = encodeURIComponent(n(o)) + r;
                  return Array.isArray(e[o])
                    ? e[o]
                        .map(function (e) {
                          return i + encodeURIComponent(n(e));
                        })
                        .join(t)
                    : i + encodeURIComponent(n(e[o]));
                })
                .join(t)
            : o
            ? encodeURIComponent(n(o)) + r + encodeURIComponent(n(e))
            : ''
        );
      };
    },
    function (e, t, n) {
      'use strict';
      (t.decode = t.parse = n(5)), (t.encode = t.stringify = n(6));
    },
  ]);
});
!(function (e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define('MRClient', [], t)
    : 'object' == typeof exports
    ? (exports.MRClient = t())
    : (e.MRClient = t());
})(this, function () {
  return (function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = (n[r] = { exports: {}, id: r, loaded: !1 });
      return e[r].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports;
    }
    var n = {};
    return (t.m = e), (t.c = n), (t.p = ''), t(0);
  })([
    function (e, t, n) {
      'use strict';
      function r(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function o(e, t) {
        if (!(e instanceof t))
          throw new TypeError('Cannot call a class as a function');
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var i =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          },
        s = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        })(),
        u = n(2),
        a = n(3),
        c = r(a),
        f = n(4),
        l = r(f),
        d = n(1),
        h = (r(d), n(7)),
        p = (function () {
          function e(t) {
            o(this, e),
              (this._apiUrl = t.apiUrl || u.API_URL),
              (this._tokenUrl = t.tokenUrl || this._apiUrl),
              (this._clientId = t.clientId),
              (this._clientSecret = t.clientSecret),
              (this._refreshRequest = null),
              (this.auth = c.default.bind(this)()),
              (this.event = l.default.bind(this)()),
              (this.event.listeners = new Map()),
              t.token && this.auth.setToken(t.token);
          }
          return (
            s(e, [
              {
                key: 'request',
                value: function (e, t) {
                  var n = this;
                  this.event.emit(u.EVENT_PRE_REQUEST, this);
                  var r = t.method,
                    o = t.query,
                    i = t.body,
                    s = new Headers(),
                    a = void 0 === t.auth || t.auth,
                    c = void 0 === t.json || t.json,
                    f = void 0 !== t.formdata && t.formdata,
                    l = this._token;
                  if (a && l) {
                    if (l.isExpired())
                      return (
                        (void 0 !== this._refreshRequest &&
                          null !== this._refreshRequest) ||
                          (this._refreshRequest = l.refreshToken
                            ? this.auth.refreshAuthentication(l.refreshToken)
                            : this.auth.applicationAuthentication()),
                        this._refreshRequest.then(function () {
                          return n.request(e, t);
                        })
                      );
                    s.append('Authorization', 'Bearer ' + l.accessToken);
                  }
                  return (
                    i &&
                      !f &&
                      (c
                        ? (s.append('Content-Type', 'application/json'),
                          (i = JSON.stringify({ data: i })))
                        : (s.append(
                            'Content-Type',
                            'application/x-www-form-urlencoded'
                          ),
                          (i = (0, h.stringify)(i)))),
                    o &&
                      (e = decodeURIComponent(e + '?' + (0, h.stringify)(o))),
                    fetch('' + (t.baseUrl ? t.baseUrl : this._apiUrl) + e, {
                      method: r,
                      headers: s,
                      body: 'GET' !== r && i ? i : void 0,
                    })
                  );
                },
              },
              {
                key: 'upload',
                value: function (e, t, n) {
                  var r = this;
                  return new Promise(function (e, n) {
                    var r = new FileReader();
                    (r.onerror = r.onabort =
                      function () {
                        return n(null);
                      }),
                      (r.onloadend = function (t) {
                        return e(t.target.result);
                      }),
                      r.readAsArrayBuffer(t);
                  }).then(function (t) {
                    return (
                      (t = new Uint8Array(t || '').reduce(function (e, t, n) {
                        return (e =
                          1 == n
                            ? String.fromCharCode(e, t)
                            : e + String.fromCharCode(t));
                      })),
                      r.request(e, {
                        method: 'POST',
                        body: i({}, n || {}, { file: btoa(t) }),
                      })
                    );
                  });
                },
              },
            ]),
            e
          );
        })();
      t.default = p;
    },
    function (e, t) {
      'use strict';
      function n(e, t) {
        if (!(e instanceof t))
          throw new TypeError('Cannot call a class as a function');
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var r = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        })(),
        o = (function () {
          function e(t) {
            n(this, e),
              (this.accessToken = t.accessToken),
              (this.refreshToken = t.refreshToken),
              (this.expiredAt = t.expiredAt);
          }
          return (
            r(e, [
              {
                key: 'isExpired',
                value: function () {
                  return this.expiredAt < Date.now();
                },
              },
            ]),
            e
          );
        })();
      t.default = o;
    },
    function (e, t) {
      'use strict';
      Object.defineProperty(t, '__esModule', { value: !0 });
      (t.API_URL = 'http://api.ma-residence.fr'),
        (t.OAUTH_TOKEN_URL = '/oauth/v2/token'),
        (t.OAUTH_GRANT_CLIENT_CREDENTIALS = 'client_credentials'),
        (t.OAUTH_GRANT_REFRESH_TOKEN = 'refresh_token'),
        (t.OAUTH_GRANT_PASSWORD = 'password'),
        (t.OAUTH_GRANT_EXTERNAL = 'urn:external'),
        (t.EVENT_PRE_REQUEST = 'pre_request'),
        (t.EVENT_PRE_AUTH = 'pre_auth'),
        (t.EVENT_POST_AUTH = 'post_auth'),
        (t.EVENT_FAIL_AUTH = 'fail_auth');
    },
    function (e, t, n) {
      'use strict';
      function r(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function o() {
        var e = this;
        return {
          applicationAuthentication: function () {
            return e.auth._requestToken({
              client_id: e._clientId,
              client_secret: e._clientSecret,
              grant_type: s.OAUTH_GRANT_CLIENT_CREDENTIALS,
            });
          },
          userAuthentication: function (t) {
            var n = { client_id: e._clientId, client_secret: e._clientSecret };
            if (t.email && t.password)
              n = i({}, n, {
                username: t.email,
                password: t.password,
                grant_type: s.OAUTH_GRANT_PASSWORD,
              });
            else {
              if (!t.token || !t.service)
                throw Error(
                  'You must specify (email, password) OR (token, service).'
                );
              n = i({}, n, {
                token: t.token,
                type: t.service,
                grant_type: s.OAUTH_GRANT_EXTERNAL,
              });
            }
            return e.auth._requestToken(n);
          },
          refreshAuthentication: function (t) {
            return e.auth
              ._requestToken({
                client_id: e._clientId,
                client_secret: e._clientSecret,
                grant_type: s.OAUTH_GRANT_REFRESH_TOKEN,
                refresh_token: t,
              })
              .then(function () {
                e._refreshRequest = null;
              });
          },
          _requestToken: function (t) {
            return (
              e.event.emit(s.EVENT_PRE_AUTH, e),
              e
                .request(s.OAUTH_TOKEN_URL, {
                  method: 'POST',
                  body: t,
                  auth: !1,
                  json: !1,
                  baseUrl: e._tokenUrl,
                })
                .then(function (t) {
                  if (200 === t.status) return t.json();
                  throw (
                    (e.auth.logout(),
                    e.event.emit(s.EVENT_FAIL_AUTH, e),
                    Error('Authentication fail!'))
                  );
                })
                .then(function (t) {
                  var n = new Date();
                  n.setSeconds(n.getSeconds() + t.expires_in);
                  var r = new a.default({
                    accessToken: t.access_token,
                    refreshToken: t.refresh_token || null,
                    expiredAt: n,
                  });
                  return (
                    e.auth.setToken(r), e.event.emit(s.EVENT_POST_AUTH, e), r
                  );
                })
            );
          },
          isAuthenticated: function () {
            return e._token && !e._token.isExpired();
          },
          logout: function () {
            (e._token = null), (e._refreshRequest = null);
          },
          setToken: function (t) {
            return (
              (e._token = new a.default({
                accessToken: t.accessToken,
                expiredAt: t.expiredAt,
                refreshToken: t.refreshToken,
              })),
              e._token
            );
          },
          getToken: function () {
            return e._token;
          },
        };
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var i =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        };
      t.default = o;
      var s = n(2),
        u = n(1),
        a = r(u);
    },
    function (e, t) {
      'use strict';
      function n() {
        var e = this;
        return {
          listeners: Map,
          _isCallable: function (e) {
            return 'function' == typeof e || !1;
          },
          addListener: function (t, n) {
            e.event._isCallable(n) &&
              (e.event.listeners.has(t) || e.event.listeners.set(t, []),
              e.event.listeners.get(t).push(n));
          },
          removeListener: function (t, n) {
            var r = e.event.listeners.get(t),
              o = void 0;
            return (
              !!(
                r &&
                r.length &&
                ((o = r.reduce(function (t, r, o) {
                  return e.event._isCallable(r) && r === n ? (t = o) : t;
                }, -1)),
                o > -1)
              ) && (r.splice(o, 1), e.event.listeners.set(t, r), !0)
            );
          },
          emit: function (t) {
            for (
              var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), o = 1;
              o < n;
              o++
            )
              r[o - 1] = arguments[o];
            var i = e.event.listeners.get(t);
            return (
              !(!i || !i.length) &&
              (i.forEach(function (e) {
                e.apply(void 0, r);
              }),
              !0)
            );
          },
        };
      }
      Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = n);
    },
    function (e, t) {
      'use strict';
      function n(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
      e.exports = function (e, t, r, o) {
        (t = t || '&'), (r = r || '=');
        var i = {};
        if ('string' != typeof e || 0 === e.length) return i;
        var s = /\+/g;
        e = e.split(t);
        var u = 1e3;
        o && 'number' == typeof o.maxKeys && (u = o.maxKeys);
        var a = e.length;
        u > 0 && a > u && (a = u);
        for (var c = 0; c < a; ++c) {
          var f,
            l,
            d,
            h,
            p = e[c].replace(s, '%20'),
            _ = p.indexOf(r);
          _ >= 0
            ? ((f = p.substr(0, _)), (l = p.substr(_ + 1)))
            : ((f = p), (l = '')),
            (d = decodeURIComponent(f)),
            (h = decodeURIComponent(l)),
            n(i, d)
              ? Array.isArray(i[d])
                ? i[d].push(h)
                : (i[d] = [i[d], h])
              : (i[d] = h);
        }
        return i;
      };
    },
    function (e, t) {
      'use strict';
      var n = function (e) {
        switch (typeof e) {
          case 'string':
            return e;
          case 'boolean':
            return e ? 'true' : 'false';
          case 'number':
            return isFinite(e) ? e : '';
          default:
            return '';
        }
      };
      e.exports = function (e, t, r, o) {
        return (
          (t = t || '&'),
          (r = r || '='),
          null === e && (e = void 0),
          'object' == typeof e
            ? Object.keys(e)
                .map(function (o) {
                  var i = encodeURIComponent(n(o)) + r;
                  return Array.isArray(e[o])
                    ? e[o]
                        .map(function (e) {
                          return i + encodeURIComponent(n(e));
                        })
                        .join(t)
                    : i + encodeURIComponent(n(e[o]));
                })
                .join(t)
            : o
            ? encodeURIComponent(n(o)) + r + encodeURIComponent(n(e))
            : ''
        );
      };
    },
    function (e, t, n) {
      'use strict';
      (t.decode = t.parse = n(5)), (t.encode = t.stringify = n(6));
    },
  ]);
});
!(function (e, t) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = t())
    : 'function' == typeof define && define.amd
    ? define('MRClient', [], t)
    : 'object' == typeof exports
    ? (exports.MRClient = t())
    : (e.MRClient = t());
})(this, function () {
  return (function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = (n[r] = { exports: {}, id: r, loaded: !1 });
      return e[r].call(o.exports, o, o.exports, t), (o.loaded = !0), o.exports;
    }
    var n = {};
    return (t.m = e), (t.c = n), (t.p = ''), t(0);
  })([
    function (e, t, n) {
      'use strict';
      function r(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function o(e, t) {
        if (!(e instanceof t))
          throw new TypeError('Cannot call a class as a function');
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var i =
          Object.assign ||
          function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n)
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            }
            return e;
          },
        s = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        })(),
        u = n(2),
        a = n(3),
        c = r(a),
        f = n(4),
        l = r(f),
        d = n(1),
        h = (r(d), n(7)),
        p = (function () {
          function e(t) {
            o(this, e),
              (this._apiUrl = t.apiUrl || u.API_URL),
              (this._tokenUrl = t.tokenUrl || this._apiUrl),
              (this._clientId = t.clientId),
              (this._clientSecret = t.clientSecret),
              (this._refreshRequest = null),
              (this.auth = c.default.bind(this)()),
              (this.event = l.default.bind(this)()),
              (this.event.listeners = new Map()),
              t.token && this.auth.setToken(t.token);
          }
          return (
            s(e, [
              {
                key: 'request',
                value: function (e, t) {
                  var n = this;
                  this.event.emit(u.EVENT_PRE_REQUEST, this);
                  var r = t.method,
                    o = t.query,
                    i = t.body,
                    s = new Headers(),
                    a = void 0 === t.auth || t.auth,
                    c = void 0 === t.json || t.json,
                    f = void 0 !== t.formdata && t.formdata,
                    l = this._token;
                  if (a && l) {
                    if (l.isExpired())
                      return (
                        (void 0 !== this._refreshRequest &&
                          null !== this._refreshRequest) ||
                          (this._refreshRequest = l.refreshToken
                            ? this.auth.refreshAuthentication(l.refreshToken)
                            : this.auth.applicationAuthentication()),
                        this._refreshRequest.then(function () {
                          return n.request(e, t);
                        })
                      );
                    s.append('Authorization', 'Bearer ' + l.accessToken);
                  }
                  return (
                    i &&
                      !f &&
                      (c
                        ? (s.append('Content-Type', 'application/json'),
                          (i = JSON.stringify({ data: i })))
                        : (s.append(
                            'Content-Type',
                            'application/x-www-form-urlencoded'
                          ),
                          (i = (0, h.stringify)(i)))),
                    o &&
                      (e = decodeURIComponent(e + '?' + (0, h.stringify)(o))),
                    fetch('' + (t.baseUrl ? t.baseUrl : this._apiUrl) + e, {
                      method: r,
                      headers: s,
                      body: 'GET' !== r && i ? i : void 0,
                    })
                  );
                },
              },
              {
                key: 'upload',
                value: function (e, t, n) {
                  var r = this;
                  return new Promise(function (e, n) {
                    var r = new FileReader();
                    (r.onerror = r.onabort =
                      function () {
                        return n(null);
                      }),
                      (r.onloadend = function (t) {
                        return e(t.target.result);
                      }),
                      r.readAsArrayBuffer(t);
                  }).then(function (t) {
                    return (
                      (t = new Uint8Array(t || '').reduce(function (e, t, n) {
                        return (e =
                          1 == n
                            ? String.fromCharCode(e, t)
                            : e + String.fromCharCode(t));
                      })),
                      r.request(e, {
                        method: 'POST',
                        body: i({}, n || {}, { file: btoa(t) }),
                      })
                    );
                  });
                },
              },
            ]),
            e
          );
        })();
      t.default = p;
    },
    function (e, t) {
      'use strict';
      function n(e, t) {
        if (!(e instanceof t))
          throw new TypeError('Cannot call a class as a function');
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var r = (function () {
          function e(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                'value' in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          return function (t, n, r) {
            return n && e(t.prototype, n), r && e(t, r), t;
          };
        })(),
        o = (function () {
          function e(t) {
            n(this, e),
              (this.accessToken = t.accessToken),
              (this.refreshToken = t.refreshToken),
              (this.expiredAt = t.expiredAt);
          }
          return (
            r(e, [
              {
                key: 'isExpired',
                value: function () {
                  return this.expiredAt < Date.now();
                },
              },
            ]),
            e
          );
        })();
      t.default = o;
    },
    function (e, t) {
      'use strict';
      Object.defineProperty(t, '__esModule', { value: !0 });
      (t.API_URL = 'http://api.ma-residence.fr'),
        (t.OAUTH_TOKEN_URL = '/oauth/v2/token'),
        (t.OAUTH_GRANT_CLIENT_CREDENTIALS = 'client_credentials'),
        (t.OAUTH_GRANT_REFRESH_TOKEN = 'refresh_token'),
        (t.OAUTH_GRANT_PASSWORD = 'password'),
        (t.OAUTH_GRANT_EXTERNAL = 'urn:external'),
        (t.EVENT_PRE_REQUEST = 'pre_request'),
        (t.EVENT_PRE_AUTH = 'pre_auth'),
        (t.EVENT_POST_AUTH = 'post_auth'),
        (t.EVENT_FAIL_AUTH = 'fail_auth');
    },
    function (e, t, n) {
      'use strict';
      function r(e) {
        return e && e.__esModule ? e : { default: e };
      }
      function o() {
        var e = this;
        return {
          applicationAuthentication: function () {
            return e.auth._requestToken({
              client_id: e._clientId,
              client_secret: e._clientSecret,
              grant_type: s.OAUTH_GRANT_CLIENT_CREDENTIALS,
            });
          },
          userAuthentication: function (t) {
            var n = { client_id: e._clientId, client_secret: e._clientSecret };
            if (t.email && t.password)
              n = i({}, n, {
                username: t.email,
                password: t.password,
                grant_type: s.OAUTH_GRANT_PASSWORD,
              });
            else {
              if (!t.token || !t.service)
                throw Error(
                  'You must specify (email, password) OR (token, service).'
                );
              n = i({}, n, {
                token: t.token,
                type: t.service,
                grant_type: s.OAUTH_GRANT_EXTERNAL,
              });
            }
            return e.auth._requestToken(n);
          },
          refreshAuthentication: function (t) {
            return e.auth
              ._requestToken({
                client_id: e._clientId,
                client_secret: e._clientSecret,
                grant_type: s.OAUTH_GRANT_REFRESH_TOKEN,
                refresh_token: t,
              })
              .then(function () {
                e._refreshRequest = null;
              });
          },
          _requestToken: function (t) {
            return (
              e.event.emit(s.EVENT_PRE_AUTH, e),
              e
                .request(s.OAUTH_TOKEN_URL, {
                  method: 'POST',
                  body: t,
                  auth: !1,
                  json: !1,
                  baseUrl: e._tokenUrl,
                })
                .then(function (t) {
                  if (200 === t.status) return t.json();
                  throw (
                    (e.auth.logout(),
                    e.event.emit(s.EVENT_FAIL_AUTH, e),
                    Error('Authentication fail!'))
                  );
                })
                .then(function (t) {
                  var n = new Date();
                  n.setSeconds(n.getSeconds() + t.expires_in);
                  var r = new a.default({
                    accessToken: t.access_token,
                    refreshToken: t.refresh_token || null,
                    expiredAt: n,
                  });
                  return (
                    e.auth.setToken(r), e.event.emit(s.EVENT_POST_AUTH, e), r
                  );
                })
            );
          },
          isAuthenticated: function () {
            return e._token && !e._token.isExpired();
          },
          logout: function () {
            (e._token = null), (e._refreshRequest = null);
          },
          setToken: function (t) {
            return (
              (e._token = new a.default({
                accessToken: t.accessToken,
                expiredAt: t.expiredAt,
                refreshToken: t.refreshToken,
              })),
              e._token
            );
          },
          getToken: function () {
            return e._token;
          },
        };
      }
      Object.defineProperty(t, '__esModule', { value: !0 });
      var i =
        Object.assign ||
        function (e) {
          for (var t = 1; t < arguments.length; t++) {
            var n = arguments[t];
            for (var r in n)
              Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
          }
          return e;
        };
      t.default = o;
      var s = n(2),
        u = n(1),
        a = r(u);
    },
    function (e, t) {
      'use strict';
      function n() {
        var e = this;
        return {
          listeners: Map,
          _isCallable: function (e) {
            return 'function' == typeof e || !1;
          },
          addListener: function (t, n) {
            e.event._isCallable(n) &&
              (e.event.listeners.has(t) || e.event.listeners.set(t, []),
              e.event.listeners.get(t).push(n));
          },
          removeListener: function (t, n) {
            var r = e.event.listeners.get(t),
              o = void 0;
            return (
              !!(
                r &&
                r.length &&
                ((o = r.reduce(function (t, r, o) {
                  return e.event._isCallable(r) && r === n ? (t = o) : t;
                }, -1)),
                o > -1)
              ) && (r.splice(o, 1), e.event.listeners.set(t, r), !0)
            );
          },
          emit: function (t) {
            for (
              var n = arguments.length, r = Array(n > 1 ? n - 1 : 0), o = 1;
              o < n;
              o++
            )
              r[o - 1] = arguments[o];
            var i = e.event.listeners.get(t);
            return (
              !(!i || !i.length) &&
              (i.forEach(function (e) {
                e.apply(void 0, r);
              }),
              !0)
            );
          },
        };
      }
      Object.defineProperty(t, '__esModule', { value: !0 }), (t.default = n);
    },
    function (e, t) {
      'use strict';
      function n(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }
      e.exports = function (e, t, r, o) {
        (t = t || '&'), (r = r || '=');
        var i = {};
        if ('string' != typeof e || 0 === e.length) return i;
        var s = /\+/g;
        e = e.split(t);
        var u = 1e3;
        o && 'number' == typeof o.maxKeys && (u = o.maxKeys);
        var a = e.length;
        u > 0 && a > u && (a = u);
        for (var c = 0; c < a; ++c) {
          var f,
            l,
            d,
            h,
            p = e[c].replace(s, '%20'),
            _ = p.indexOf(r);
          _ >= 0
            ? ((f = p.substr(0, _)), (l = p.substr(_ + 1)))
            : ((f = p), (l = '')),
            (d = decodeURIComponent(f)),
            (h = decodeURIComponent(l)),
            n(i, d)
              ? Array.isArray(i[d])
                ? i[d].push(h)
                : (i[d] = [i[d], h])
              : (i[d] = h);
        }
        return i;
      };
    },
    function (e, t) {
      'use strict';
      var n = function (e) {
        switch (typeof e) {
          case 'string':
            return e;
          case 'boolean':
            return e ? 'true' : 'false';
          case 'number':
            return isFinite(e) ? e : '';
          default:
            return '';
        }
      };
      e.exports = function (e, t, r, o) {
        return (
          (t = t || '&'),
          (r = r || '='),
          null === e && (e = void 0),
          'object' == typeof e
            ? Object.keys(e)
                .map(function (o) {
                  var i = encodeURIComponent(n(o)) + r;
                  return Array.isArray(e[o])
                    ? e[o]
                        .map(function (e) {
                          return i + encodeURIComponent(n(e));
                        })
                        .join(t)
                    : i + encodeURIComponent(n(e[o]));
                })
                .join(t)
            : o
            ? encodeURIComponent(n(o)) + r + encodeURIComponent(n(e))
            : ''
        );
      };
    },
    function (e, t, n) {
      'use strict';
      (t.decode = t.parse = n(5)), (t.encode = t.stringify = n(6));
    },
  ]);
});
